import { identity } from 'ramda';
import React, { useState, useEffect, useRef } from 'react';

import { Container, Label, LabelError, Input } from '../inputs.style';

export const InputText = ({
  placeHolder,
  type,
  label,
  error,
  disabled,
  value: valueProp,
  onChange,
  ...props
}) => {
  const inputRef = useRef(null);
  const [focus, setFocus] = useState(false);
  const [value, setValue] = useState('');

  const handleOnblur = () => {
    if (value === '') {
      setFocus(false);
    } else {
      setFocus(true);
    }
  };

  useEffect(() => {
    if (value !== valueProp) {
      setValue(valueProp ? valueProp : '');
      setFocus(true);
    }
  }, []);

  const handleOnChange = e => {
    setValue(e.target.value);
  };

  return (
    <Container>
      <Label
        {...props}
        error={error}
        focus={focus}
        onClick={
          disabled
            ? () => {}
            : () => {
                setFocus(true);
                inputRef.current.focus();
              }
        }>
        {label}
      </Label>

      {error && (
        <LabelError {...props} focus={focus}>
          {error}
        </LabelError>
      )}

      <Input
        {...props}
        ref={inputRef}
        value={value}
        type={type}
        disabled={disabled}
        error={error}
        onInput={handleOnChange}
        onChange={onChange}
        onFocus={() => setFocus(true)}
        onBlur={handleOnblur}
      />
    </Container>
  );
};

InputText.defaultProps = {
  onChange: () => {},
};
